
import { MapLocation } from '@/types/location';

// Pool Challenge Cafe Locations
export const poolChallengeCafes: MapLocation[] = [
  {
    id: 44001,
    name: "Pool Challenge Cafe - Jeddah (Al Safa)",
    type: "Game Center",
    devices: 4,
    coordinates: [21.58258515597155, 39.20670843443807],
    region: "Jeddah",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
